<reportTable *ngIf="rows" [headers]="tableHeaders" [rows]="rows" [isManual]="isManual"></reportTable>